import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestMarkExpeditionAsDelivered } from "./markExpeditionAsDelivered.request";

const useMarkExpeditionAsDelivered = (
  options?: MutationOptions<void, ApiServiceError<ApiError>, string>
) => {
  return useMutation({
    mutationFn: requestMarkExpeditionAsDelivered,
    ...options
  });
};

export default useMarkExpeditionAsDelivered;
